import { IntlShape } from 'react-intl';
import dayjs from 'dayjs';

/**
 * When an entry happened, as the stream writes it (#2154).
 *
 * The day headers the timeline used to draw are gone with the row form, so the
 * date moved into the row itself. Near dates read as words because that is how
 * someone scanning a document thinks about them; anything older than a week is
 * a date again, and a different year always says which one.
 */
export const formatStreamTime = (value: string, intl: IntlShape): string => {
    const moment = dayjs(value);

    if (!moment.isValid()) {
        return '';
    }

    const now = dayjs();
    const time = moment.format('HH:mm');
    const days = now.startOf('day').diff(moment.startOf('day'), 'day');

    if (0 === days) {
        return intl.formatMessage({ id: 'app.stream.time.today' }, { time });
    }

    if (1 === days) {
        return intl.formatMessage({ id: 'app.stream.time.yesterday' }, { time });
    }

    if (days < 7 && days > 0) {
        return `${moment.format('dd')} ${time}`;
    }

    return moment.year() === now.year() ? moment.format('DD.MM. HH:mm') : moment.format('DD.MM.YYYY HH:mm');
};
